import { SIZE, StyledDivider } from 'baseui/divider'
import { StyledMenuDivider } from '../styled-components'

interface MenuDividerProps {
  hidden: boolean
}

const MenuDivider = ({ hidden }: MenuDividerProps) => {
  if (hidden) return null

  return (
    <StyledMenuDivider role='separator'>
      <StyledDivider $size={SIZE.section} />
    </StyledMenuDivider>
  )
}

export default MenuDivider
